import _ from 'lodash';
import { MENU_CATEGORIES } from '@nandosaus/constants';
import { observer } from 'mobx-react';
import { productsArrayPropTypes } from '@nandosaus/prop-types';
import PropTypes from 'prop-types';

import { AlcoholProductCategory } from './alcohol-product-category';
import { Container, Box } from '../grid';
import { createNavId } from '../../utils/createNavIds';
import { DeliveryDiscountCategoryDescription } from './delivery-discount-category-description';
import { ProductCategory } from './product-category';
import { useFeature } from '../../hooks/use-feature';

const categoryMap = {
  [MENU_CATEGORIES.ALCOHOL]: AlcoholProductCategory,
};

const ProductCategoryList = ({
  CardComponent,
  categories,
  viewProduct,
  isDelivery,
  isDeliveryDiscountActive,
  quantityPicker,
  hideDescription,
  isSearch,
}) => {
  const hiddenMenuCategory = useFeature('hidden-menu-category');
  const dietaryPreferenceCategory = _.chain(categories)
    .filter(category => category.products.length !== 0)
    .filter(category => !hiddenMenuCategory?.categoryHandles?.includes(category.handle))
    .value();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={isSearch ? { xs: '40px', md: '60px' } : { xs: '40px', md: '80px' }}
      >
        {dietaryPreferenceCategory.map(category => {
          const id = createNavId(category.name);
          const CategoryComponent = categoryMap[category.handle] || ProductCategory;
          const showDiscountDescription =
            category.handle === MENU_CATEGORIES.SPIN_TO_WIN && isDelivery && isDeliveryDiscountActive;

          return (
            <Container key={id} id={id}>
              <Box>
                <CategoryComponent
                  {...{
                    category: {
                      ...category,
                      description: showDiscountDescription ? (
                        <DeliveryDiscountCategoryDescription />
                      ) : (
                        category.description
                      ),
                    },
                    CardComponent,
                    viewProduct,
                    quantityPicker,
                    hideDescription,
                  }}
                />
              </Box>
            </Container>
          );
        })}
      </Box>
    </>
  );
};

ProductCategoryList.propTypes = {
  CardComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      handle: PropTypes.string.isRequired,
      description: PropTypes.string,
      products: productsArrayPropTypes,
    })
  ).isRequired,
  viewProduct: PropTypes.func.isRequired,
  isDelivery: PropTypes.bool.isRequired,
  isDeliveryDiscountActive: PropTypes.bool,
  quantityPicker: PropTypes.bool,
  hideDescription: PropTypes.bool,
  isSearch: PropTypes.bool,
};

ProductCategoryList.defaultProps = {
  isDeliveryDiscountActive: false,
  quantityPicker: false,
  hideDescription: false,
  isSearch: false,
};

const ComposedProductCategoryList = observer(ProductCategoryList);
export { ComposedProductCategoryList as ProductCategoryList };
